import { Button, ButtonDesign, MessageBox, MessageBoxTypes } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import '@ui5/webcomponents-icons/dist/complete';
import { useDeleteQueryByIdMutation } from 'generated/graphql';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import useGlobalToastMessageStore from 'stores/GlobalToastMessageStore';
import { useHistory } from 'react-router-dom';
import { ResultUserMessage } from 'components/shared/UserMessage';

export interface DeleteQueryProps {
  id: string;
  setResultMessage: (value: ResultUserMessage) => void;
  setIsUserMessageOpen: (value: boolean) => void;
}

export const DeleteQuery: React.FC<DeleteQueryProps> = (props) => {
  const { id, setResultMessage, setIsUserMessageOpen } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const showToast = useGlobalToastMessageStore((state) => state.showToast);

  const [, deleteQueryMutation] = useDeleteQueryByIdMutation();

  const onConfirm = async () => {
    const { error } = await deleteQueryMutation({ id: Number(id) });
    if (error) {
      setResultMessage({
        isSuccess: false,
        message: t('display-query-actions-delete-error-message')
      });
      setIsUserMessageOpen(true);
      return;
    }

    showToast(t('display-query-actions-delete-success-message', { id }));
    redirectToMainPage();
  };

  const redirectToMainPage = () => history.push('/queries');

  const renderConfirmationDialog = () => {
    return createPortal(
      <MessageBox
        open={isConfirmDialogOpen}
        type={MessageBoxTypes.Confirm}
        onClose={() => setIsConfirmDialogOpen(false)}
        actions={[
          <Button
            key="confirm-delete-query-button"
            id="confirm-delete-query-button"
            data-testid="confirm-delete-query-button"
            onClick={onConfirm}
            design={ButtonDesign.Default}
          >
            {t('confirm')}
          </Button>,
          <Button
            key="cancel-delete-query-button"
            id="cancel-delete-query-button"
            data-testid="cancel-delete-query-button"
            design={ButtonDesign.Emphasized}
          >
            {t('cancel')}
          </Button>
        ]}
      >
        {t('display-query-actions-delete-confirm-dialog-message')}
      </MessageBox>,
      document.body
    );
  };

  return (
    <>
      <Button
        className={'button-bg-white'}
        data-testid="display-query-delete-query"
        data-help-id="display-query-delete-query"
        id="delete-query-button"
        onClick={() => setIsConfirmDialogOpen(true)}
        design={ButtonDesign.Negative}
      >
        {t('display-query-delete-button')}
      </Button>
      {renderConfirmationDialog()}
    </>
  );
};
